import { render, staticRenderFns } from "./ApeUploader.vue?vue&type=template&id=652880b2&scoped=true"
import script from "./ApeUploader.vue?vue&type=script&lang=js"
export * from "./ApeUploader.vue?vue&type=script&lang=js"
import style0 from "./ApeUploader.vue?vue&type=style&index=0&id=652880b2&prod&scoped=true&lang=css"
import style1 from "./ApeUploader.vue?vue&type=style&index=1&id=652880b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652880b2",
  null
  
)

export default component.exports